import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { PostCard } from "@/components/PostCard";
import { api } from "@/lib/api";

// Home-page teaser: the three newest published posts. Renders nothing until the first post exists.
export const LatestWriting = () => {
  const { t } = useLang();
  const { data: posts = [] } = useQuery({ queryKey: ["posts", "latest"], queryFn: () => api("/api/posts?limit=3") });
  if (posts.length === 0) return null;

  return (
    <section id="blog" data-testid="latest-writing-section" className="bg-ink py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <SectionHeading eyebrow={t.blog.eyebrow} title={t.blog.title} titleItalic={t.blog.titleItalic} description={t.blog.description} />
          <Reveal delay={0.2}>
            <Link
              to="/blog"
              data-testid="latest-writing-view-all"
              className="group flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-ember transition-colors duration-200 hover:text-emberHover"
            >
              {t.blog.viewAll}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </Link>
          </Reveal>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {posts.map((post, i) => (
            <Reveal key={post.id} delay={i * 0.08}>
              <PostCard post={post} testId={`latest-post-${i}`} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
